import React from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  FormFeedback
} from 'reactstrap';
import withValidation from '../withValidation';
import styles from './styles.scss';


class TextInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event.target.value);
    }
  }

  render() {
    const {
      value,
      type,
      invalid,
      error,
      disabled,
      onBlur,
      step,
      placeholder
    } = this.props;

    return [
      <Input className={styles.input}
        key='input'
        value={value}
        type={type}
        onChange={this.onChange}
        onBlur={onBlur}
        step={step}
        invalid={invalid}
        disabled={disabled}
        placeholder={placeholder}
      />,
      <FormFeedback
        key='feedback'
        className='text-left'
      >
        {error}
      </FormFeedback>
    ];
  }
}

TextInput.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  step: PropTypes.string,
  error: PropTypes.string,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};


export default withValidation(TextInput);



// WEBPACK FOOTER //
// src/components/shared/TextInput/index.jsx